var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.999 101.558L346.324 244.883C350.374 249.683 352.024 254.183 352.024 258.008C352.024 261.833 350.359 266.986 347.008 270.451L208.999 414.451C202.174 421.648 190.099 421.882 183.574 414.991C176.355 408.147 176.12 396.706 183.035 389.558L309.124 258.008L183.124 126.458C176.209 119.333 176.444 107.873 183.663 101.026C190.099 94.1333 202.174 94.3583 208.999 101.558Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.e18afb16feb8e565d7ae05ac30ee7131.svg";
export { ForwardRef as ReactComponent };